import { Credit } from 'interfaces';
import { buildCredit } from '../../factories';
import { providerRefs, siteRefs } from '../../factories/seeds/entities';
import { mockProviders } from './providerMock';
import { mockSites } from './siteMock';

const providerByID = new Map(
  mockProviders.map((provider) => [provider.id, provider])
);
const siteByID = new Map(mockSites.map((site) => [site.id, site]));

const creditProvider = providerByID.get(providerRefs.adamDonen.id) ?? null;
const creditSite = siteByID.get(siteRefs.qdocVirtualHealthcare.id) ?? null;

export const mockCredits: Credit[] = [
  buildCredit<Credit>({
    id: 'c4aa38ff-b467-4129-8545-a0772befbde6',
    siteID: creditSite?.id ?? '',
    providerID: creditProvider?.id ?? '',
    amount: '174.14',
    date: '2024-12-13T23:03:59.378Z',
    description: '',
    filename: 'P4 20240715 QDOC038H INT.TXT',
    provider: creditProvider,
    site: creditSite,
  }) as Credit,
  buildCredit<Credit>({
    id: '7ae5e784-29fd-49db-92fc-220afa26de71',
    siteID: creditSite?.id ?? '',
    providerID: creditProvider?.id ?? '',
    amount: '0.15',
    date: '2024-12-13T23:03:59.378Z',
    description: 'INTEREST',
    filename: 'P4 20240715 QDOC038H INT.TXT',
    provider: creditProvider,
    site: creditSite,
  }) as Credit,
  buildCredit<Credit>({
    id: '024117ce-2f6b-43e2-beec-986941fb4789',
    siteID: creditSite?.id ?? '',
    providerID: creditProvider?.id ?? '',
    amount: '2.15',
    date: '2024-12-13T22:19:15.820Z',
    description: 'INTEREST',
    filename: 'P4 20240715 QDOC038H INT.TXT',
    provider: creditProvider,
    site: creditSite,
  }) as Credit,
];
